export { default } from "./LoadingIcon";
